import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import Peningkatan from "./modules/Manajemen Penjaminan Mutu/Peningkatan/Peningkatan";
import Pengendalian from "./modules/Manajemen Penjaminan Mutu/Pengendalian/Pengendalian";
import Role from "./modules/Manajemen Akses/Role/List/Index";
import User from "./modules/Manajemen Akses/User/List/Index";
import UserAdd from "./modules/Manajemen Akses/User/Add/Index";
import UserEdit from "./modules/Manajemen Akses/User/Edit/Index";
import ResetPassword from "./modules/Manajemen Akses/User/ResetPassword/Index";
import DashboardPelaksanaan from "./modules/Manajemen Penjaminan Mutu/Pelaksanaan/DashboardPelaksanaan";
import Evaluasi from "./modules/Manajemen Penjaminan Mutu/Evaluasi/Evaluasi";
import ManajemenPenjaminanMutu from "./modules/Manajemen Penjaminan Mutu/ManajemenPenjaminanMutu";
import Profile from "./modules/Profile";
import Dashboard from "./modules/Dashboard/Dashboard";
import PresentaseMengisi from "./modules/Dashboard/Display/details-spmi/PresentaseMengisi";
import YangMengisi from "./modules/Dashboard/Display/details-spmi/YangMengisi";
import YangMengisiLengkap from "./modules/Dashboard/Display/details-spmi/YangMengisiLengkap";
import DetailPTSPMI from "./modules/Manajemen Penjaminan Mutu/DetailPTSPMI";
import VerifikatorPengaturan from "./modules/Manajemen Penjaminan Mutu/Penetapan/content/Verifikator";
import VerifikatorEvaluasi from "./modules/Manajemen Penjaminan Mutu/Evaluasi/content/Verifikator";
import VerifikatorPeningkatan from "./modules/Manajemen Penjaminan Mutu/Peningkatan/content/Verifikator";
import VerifikatorPengendalian from "./modules/Manajemen Penjaminan Mutu/Pengendalian/content/Verifikator";
import PenugasanFaswilList from "./modules/PenugasanFaswil/List/Index";
import PenugasanFaswilAdd from "./modules/PenugasanFaswil/Add/Index";
import Rekapitulasi from "./modules/Rekapitulasi/List/Index";
import Rekap from "./modules/Rekap/Index";
import RekapitulasiLembaga from "./modules/Rekapitulasi/DetailLembaga/Index";
import RekapitulasiPT from "./modules/Rekapitulasi/DetailPT/Index";
import RekapitulasiPTList from "./modules/Rekapitulasi/DetailPTList/Index";
import ContentManagementSystem from "./modules/Informasi/ContentManagementSystem/Index";
import AddContent from "./modules/Informasi/ContentManagementSystem/Add/Index";
import Informasi from "./modules/Informasi/Index";
import LogData from "./modules/Log Data/Index";
import PengelolaAdminPt from "./modules/Pengelola PT/List/Index";
import DampakTridharma from "./modules/DampakTridharma/DampakTridharma";
import DampakTridharmaVerifikator from "./modules/DampakTridharma/content/Verifikator";
import Notification from "./modules/Notification/Index";
const GoogleMaterialPage = lazy(() =>
  import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);
const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);
const StandarSpmi = lazy(() =>
  import("./modules/Manajemen Penjaminan Mutu/Penetapan/StandarSpmi")
);
const StandarPerguruanTinggi = lazy(() =>
  import("./modules/Manajemen Penjaminan Mutu/Penetapan/StandarPerguruanTinggi")
);
const PedomanSiklus = lazy(() =>
  import(
    "./modules/Manajemen Penjaminan Mutu/Penetapan/PedomanSiklusPage"
  )
);
const StandarLainYangDitambahkan = lazy(() =>
  import(
    "./modules/Manajemen Penjaminan Mutu/Penetapan/StandarLainYangDitambahkan"
  )
);
const MekanismePendokumentasian = lazy(() =>
  import("./modules/Manajemen Penjaminan Mutu/Penetapan/MekanismePendokumentasian")
);
const sessiodata = JSON.parse(localStorage.getItem("sessiondata"));
export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          <Redirect
            exact
            from="/"
            to={
              sessiodata.i_idrole === 3 || sessiodata.i_idrole === 6
                ? "/mpm"
                : "/dashboard"
            }
          />
        }
        <ContentRoute path="/mpm" component={ManajemenPenjaminanMutu} />
        <ContentRoute path="/dashboard" component={Dashboard} />
        <ContentRoute
          path="/kelengkapan-mengisi"
          component={PresentaseMengisi}
        />
        <ContentRoute path="/mengisi" component={YangMengisi} />
        <ContentRoute path="/mengisilengkap" component={YangMengisiLengkap} />
        <ContentRoute path="/profile" component={Profile} />
        <ContentRoute path="/detail-pt/:id" component={DetailPTSPMI} />
        <ContentRoute path="/search-pt" component={DetailPTSPMI} />
        {/* PENETAPAN */}
        <ContentRoute
          path="/penetapan/pengaturan-komitmen-mutu"
          component={StandarSpmi}
        />
        <ContentRoute
          path="/ajuan-pengaturan/detail/"
          component={VerifikatorPengaturan}
        />
        <ContentRoute
          path="/penetapan/standar-yang-ditetapkan-institusi"
          component={StandarPerguruanTinggi}
        />
        <Route
          path="/penetapan/pedoman-siklus"
          component={PedomanSiklus}
        />
        <ContentRoute
          path="/penetapan/standar-lainnya"
          component={StandarLainYangDitambahkan}
        />
        <ContentRoute
          path="/penetapan/mekanisme-pendokumentasian"
          component={MekanismePendokumentasian}
        />

        <ContentRoute path="/pelaksanaan" component={DashboardPelaksanaan} />
        <ContentRoute path="/evaluasi" component={Evaluasi} />
        <ContentRoute
          path="/ajuan-evaluasi/detail/"
          component={VerifikatorEvaluasi}
        />
        <ContentRoute path="/pengendalian" component={Pengendalian} />
        <ContentRoute
          path="/ajuan-pengendalian/detail"
          component={VerifikatorPengendalian}
        />
        <ContentRoute path="/peningkatan" component={Peningkatan} />
        <ContentRoute
          path="/ajuan-peningkatan/detail/"
          component={VerifikatorPeningkatan}
        />
        <ContentRoute path="/role" component={Role} />
        <ContentRoute path="/user" component={User} />        
        <ContentRoute path="/add-user" component={UserAdd} />        
        <ContentRoute path="/edit-profil" component={UserEdit} />        
        <ContentRoute path="/reset-password/:id" component={ResetPassword} />      
        <ContentRoute path="/penugasan-faswil" component={PenugasanFaswilList} />     
        <ContentRoute path="/penugasan-faswil-add" component={PenugasanFaswilAdd} />    
        {/* <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} /> */}
        <Route path="/google-material" component={GoogleMaterialPage} />
        <Route path="/react-bootstrap" component={ReactBootstrapPage} />
        <Route path="/e-commerce" component={ECommercePage} />
        <Route path="/user-profile" component={UserProfilepage} />

        {/* REKAPITULASI */}
        <ContentRoute path="/rekapitulasi" component={Rekapitulasi} />
        <ContentRoute path="/rekap" component={Rekap} />
        <ContentRoute path="/detail-lembaga/" component={RekapitulasiLembaga} />
        <ContentRoute path="/detail-pt/" component={RekapitulasiPT} />
        <ContentRoute path="/daftar-pt/" component={RekapitulasiPTList} />

        {/* INFORMASI */}
        <ContentRoute path="/content-management-system" component={ContentManagementSystem} />
        <ContentRoute path="/add-content" component={AddContent} />
        <ContentRoute path="/edit-content/:id" component={AddContent} />
        <ContentRoute path="/informasi" component={Informasi} />
        <ContentRoute path="/notification" component={Notification} />

        {/* LOG */}
        <ContentRoute path="/log-data" component={LogData} />
        {/* pengelola pt */}
        <ContentRoute path="/pengelola-pt" component={PengelolaAdminPt} />
        <ContentRoute path="/dampak-tridharma" component={DampakTridharma} />
        <ContentRoute path="/dampak-tridharma-detail/:id" component={DampakTridharmaVerifikator} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
